import React, { useState } from "react";

import { RxCheck } from "react-icons/rx";
import { toFarsiNumber } from "../../helper/helper";

const Stepper = ({ stepNum, registered }) => {
  const registerSteps = ["احراز هویت", "تایید پیامکی", "تکمیل اطلاعات"];
  const loginSteps = ["احراز هویت", "تایید رمز عبور"];
  const [currentStep, setCurrentStep] = useState(1);
  const [completed, setCompleted] = useState(false);

  // const nexStepHandler = () => {
  //     currentStep === steps.length ? setCompleted(true) : setCurrentStep(prev => prev + 1)
  // }

  // const prevStepHandler = () => {
  //     setCompleted(false)
  //     currentStep > 0 <= steps.length && setCurrentStep(prev => prev - 1)
  // }

  return (
    <div>
      {registered ? (
        <div className="w-96 flex justify-center">
          {loginSteps?.map((step, index) => (
            <div
              key={index}
              className={`step-item ${stepNum === index + 1 && "active"} ${
                (index + 1 < stepNum || completed) && "completed"
              } relative flex flex-col justify-center items-center w-36`}
            >
              <div className="step w-8 h-8 flex items-center justify-center z-10 relative bg-gray-700 rounded-full font-semibold text-white">
                {index + 1 < stepNum || completed ? (
                  <RxCheck size={24} />
                ) : (
                  toFarsiNumber(index + 1)
                )}
              </div>
              <p className="text-sm mt-2 text-gray-200">{step}</p>
            </div>
          ))}
        </div>
      ) : (
        <div className="w-96 flex">
          {registerSteps?.map((step, index) => (
            <div
              key={index}
              className={`step-item ${stepNum === index + 1 && "active"} ${
                (index + 1 < stepNum || completed) && "completed"
              } relative flex flex-col justify-center items-center w-36`}
            >
              <div className="step w-8 h-8 flex items-center justify-center z-10 relative bg-gray-700 rounded-full font-semibold text-white">
                {index + 1 < stepNum || completed ? (
                  <RxCheck size={24} />
                ) : (
                  toFarsiNumber(index + 1)
                )}
              </div>
              <p className="text-sm mt-2 text-gray-200">{step}</p>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default Stepper;
